import { ProductDetail } from "@interfaces/dto/product-detail.dto";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LineShareButton,
  LineIcon,
} from "next-share";

interface Props {
  productKey: string | string[] | undefined;
  productDetail: ProductDetail;
}

const SocialShare = ({ productKey, productDetail }: Props) => {
  const shareHost = process.env.NEXT_PUBLIC_SITEMAP_HOST;
  const shareUrl = productKey ? `${shareHost}/products/${productKey}` : "";
  const shareTitle = productDetail?.name;
  // const shareHashtag = "#topvalue";

  // const shareUrl = "https://github.com/next-share";
  // const shareTitle =
  //   "next-share is a social share buttons for your next React apps.";
  // const shareHashtag = "#nextshare";
  return (
    <div className="social">
      {/* <a href="#">
        <i className="icon icon-facebook" />
      </a>
      <a href="#">
        <i className="icon icon-twitter" />
      </a> */}

      <div className="d-flex">
        <div>
          <FacebookShareButton
            url={shareUrl}
            quote={shareTitle}
            // hashtag={shareHashtag}
          >
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>

        <div className="ps-2">
          <TwitterShareButton url={shareUrl} title={shareTitle}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
        </div>

        <div className="ps-2">
          <LineShareButton url={shareUrl} title={shareTitle}>
            <LineIcon size={32} round />
          </LineShareButton>
        </div>
      </div>
    </div>
  );
};

export default SocialShare;
